/* eslint-disable eqeqeq */
/* eslint-disable no-eval */
// JavaScript source code
import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
} from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import CenteredSpinner from './CenteredSpinner';
import { useQuery } from 'react-query';
import Select from 'react-select';
import { Button, Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { AudioModal } from './modals/AudioModal';
import { VendorSearchModal } from './modals/VendorSearchModal';
import * as AppConstants from '../AppConstants';
import { getSysSetting } from '../Utils';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { numberWithCommas } from '../Utils';


export function PropertyInspectionForm() {
  const [values, setValues] = useState({});
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [locations, setLocations] = useState('');
  const [usedFor, setUsedFor] = useState('false');
  const [addressType, setAddressType] = useState('false');
  const [availableFor, setAvailableFor] = useState('false');
  const [propertyTypeId, setPropertyTypeId] = useState(null);
  const [propertySubTypeId, setPropertySubTypeId] = useState('');
  const [localityId, setLocalityId] = useState('');
  const [streetId, setStreetId] = useState('');
  const [streetName, setStreetName] = useState('');
  const navigate = useNavigate();
  const [propertyTypeGroupId, setPropertyTypeGroupId] =
    useState(null);
  const [soleAgency, setSoleAgency] = useState('1');
  const [soleAgencyStartDate, setSoleAgencyStartDate] = useState(null);
  const [soleAgencyEndDate, setSoleAgencyEndDate] = useState(null);
  const [state, setState] = useState(null);
  const [areaTypeId, setAreaTypeId] = useState(null);
  const [price, setPrice] = useState('');
  const [showRecorder, setShowRecorder] = useState(false);
  const refPropertyTypeId = useRef(null);
  const refStreetId = useRef(null);
  const refLocalityId = useRef(null);
  const refStateId = useRef(null);
  const refImage = useRef(null);
  const refPropertySubTypeId = useRef(null);
  const refAreaTypeId = useRef(null);
  const [disabled, setDisabled] = useState(false);
  const [localityApi, setLocalityApi] = useState(null);
  const [stateApi, setStateApi] = useState(null);
  const [showImage, setShowImage] = useState(false);
  const [showVendorModal, setShowVendorModal] = useState(false);
  const [vendorAddressId, setVendorAddressId] = useState(null);
  const [propertyTypeApi, setPropertyTypeApi] = useState(null);
  const [images, setImages] = useState(null);
  const [errorImages, setErrorImages] = useState(null);
  const [multipleFiles, setMulitpleFiles] = useState(null);
  const [base64StringWavAudio, setBase64StringWavAudio] =
    useState(null);
  const [imagesFiles, setImagesFiles] = useState(null);
  const [mountRefImages, setMountRefImages] = useState(null);
  const [audioData, setAudioData] = useState(null);
  const [dataChunksAudio, setDataChunksAudio] = useState([]);
  const [activeSubmit, setActiveSubmit] = useState(false);
  const [recState, setRecState] = useState('');
  const [recStateMsg, setRecStateMsg] = useState('');
  const [staffMemberId] = useState(
    localStorage.getItem('staffMemberId'),
  );
  const [timer, setTimer] = useState(0);
  const increment = useRef(null);
  const [emphyteusis, setEmphyteusis] = useState('');
  const [groundRent, setGroundRent] = useState('');
  const [expiresIn, setExpiresIn] = useState('');
  const [revisableEvery, setRevisableEvery] = useState('');
  const refGroundRent = useRef();
  const refSaStart = useRef();
  const refSaEnd = useRef();
  const refExpiresIn = useRef();
  const refRevisableEvery = useRef();
  const [startDate, setStartDate] = useState(null);

  useEffect(() => {
    document.title = 'Property Form';
  }, []);

  const emphyteusisData = [
    { value: '1', label: 'Freehold' },
    { value: '2', label: 'Temporary' },
    { value: '3', label: 'Temporary revisable' },
    { value: '4', label: 'Perpetual' },
    { value: '5', label: 'Perpetual revisable' },
  ];

  const postDataToAPI = useCallback(() => {
    if (Object.keys(errors).length === 0 && isSubmitting) {
      let d = new Date();
      let isoDate = d.toISOString();
      setActiveSubmit(true);
      setDisabled(true);

      let AddressIndividualorOrganisation =
        addressType === 'false'
          ? {
              AddressIndividual: true, //False = organisation
              AddressIndividualFirstName: values.firstname,
              AddressIndividualSurname: values.surname,
              AddressNationalityId: 1,
              AddressIndividualIdCardNo: values.passportNumber,
            }
          : {
              AddressIndividual: false, //False = organisation
              AddressLine1: values.propertyAddressDoorNo,
              AddressLine2: values.propertyAddressName,
              AddressNationalityId: 1,
              AddressOrganisationCompanyRegNo: values.companyNameReg,
              AddressOrganisationName: values.companyName, //Required if AddressIndividual = False
            };

      const address = {
        method: 'POST',
        url: '/address',
        data: {
          AddressCountryId: 1,
          AddressEmails: [
            {
              AddressId: 0,
              EmailAddress: values.email,
              IsMain: true,
            },
          ],
          AddressGdprOptInMethodId: 2,
          AddressGdprOptInMethodDescription: null,
          ...AddressIndividualorOrganisation,
          AddressPhones: [
            {
              PhoneType: 3, //Mobile
              Prefix: '00 356', //This is coming from Country.PhoneNoPrefix. Max Length 6
              TelephoneNo: values.mobileNo, //Max Length 80
            },
          ],
          AddressPostCode: null,
          AddressTypeId: 2, //Vendor, use this
        },
      };

      const addressRequest = vendorAddressId
        ? Promise.resolve({ status: 201, data: { message: vendorAddressId } })
        : axios.request(address);

      addressRequest
        .then((response) => {
          if (response.status === 201) {
            const addrId = vendorAddressId || response.data.message;
            var convertPrice = price;
            convertPrice = convertPrice.replace(/\,/g, '');
            convertPrice = Number(convertPrice);
            let PropertyForSale =
              availableFor === 'false'
                ? {
                    PropertyId: 0,
                    Price: convertPrice,
                    Maintenance: 0,
                    Emphyteusis: emphyteusis,
                    GroundRent: groundRent,
                    GroundRentExpiryYear: expiresIn,
                    GroundRentReviseYears: revisableEvery,
                    GroundRentPayableToId: null,
                    GroundRentPayableToName: null,
                  }
                : null;

            let PropertyToLet =
              availableFor === 'true'
                ? {
                    PropertyId: 0,
                    PriceIsPerSqmtr: false,
                    LongLetRate: price,
                    LeaseRatePeriod: null,
                    PermitNo: null,
                    LettingVatBandId: null,
                    LettingType: null,
                    LandlordAddressId: null,
                    LettingNextAvail: startDate,
                    LongLetXRate: null,
                    ShortLetSummer: false,
                    LettingVatBandName: null,
                    LandlordAddressName: null,
                  }
                : {
                    PropertyId: 0,
                    PriceIsPerSqmtr: false,
                    LongLetRate: 0.0,
                    LeaseRatePeriod: null,
                    PermitNo: null,
                    LettingVatBandId: null,
                    LettingType: null,
                    LandlordAddressId: null,
                    LettingNextAvail: null,
                    LongLetXRate: null,
                    ShortLetSummer: false,
                    LettingVatBandName: null,
                    LandlordAddressName: null,
                  };

            let ForSaleOrToLet =
              availableFor === 'false' ? false : true;

            const options = {
              method: 'POST',
              url: '/property',
              data: {
                IsDraft: true,
                InputDate: isoDate, //Now
                InputBy: localStorage.getItem("username"),
                MarketStatus: 2, //Use this
                MarketStatusCode: 'DRFT', //Draft Status
                OwnerLastContacted: null,
                OwnerLastContactedString: null,
                OwnerLastContactedByStaffId: null,
                CountryId: 1,
                AddressLine1: values.propertyAddressDoorNo,
                AddressLine2: values.propertyAddressName,
                AddressLine3: streetName,
                StreetId: streetId,
                LocalityId: localityId,
                PostCode: null,
                ReqFeedback: false,
                CLSigned: false,
                DateRegistered: isoDate, //Now
                Commercial: false,
                ForSaleOrToLet: ForSaleOrToLet, //False = For Sale, True = To Let
                LettingLongLet: 0,
                LettingShortLet: 0,
                PropertyTypeId: propertyTypeId,
                PropertySubTypeId: propertySubTypeId,
                PropertyStateId: state,
                PropertyAreaTypeId: areaTypeId,
                ViewingNegotiatorId: staffMemberId,
                ShortDescription: `${localityApi} ${stateApi} ${propertyTypeApi}`, //Concat Locality, Property State and Property Type
                SoleAgencyId: soleAgency, //0 = Open Agency, 1 = Sole Agency. Please test with 0. 1 requires the followng three fields.
                SoleAgencyStartDate: soleAgencyStartDate,
                SoleAgencyExpDate: soleAgencyEndDate,
                SoleAgencyNegotiatorId: staffMemberId,
                CurrentStateId: 1,
                GoogleMapLongitude: locations.longitude,
                GoogleMapLatitude: locations.latitude,
                LastViewed: isoDate, //Now
                TotalPropertyArea: 0.0,
                VendorAddressList: [
                  {
                    AddressId: Number(addrId),
                    MainOwner: true,
                    IsNewAddress: false,
                  },
                ],
                //Only required when ForSaleOrToLet = false
                PropertyForSale: PropertyForSale,
                //Only required when ForSaleOrToLet = true
                PropertyToLet: PropertyToLet,
                //Only required when Commercial = true
                PropertyCommercial: {
                  PropertyId: 0,
                  CommercialLicenceId: null,
                  Premium: null,
                  CommLeaseYears: null,
                  CommLeaseReviseYears: null,
                  CommercialLicenceName: null,
                },
              },
            };

            axios
              .request(options)
              .then(async (response) => {
                if (response.status === 201) {
                  let ftc = response.data.propertyRef.substring(0, 2);
                  let ffc = response.data.propertyRef.substring(0, 4);

                  if (multipleFiles !== null) {
                    const payload = await Promise.all(
                      multipleFiles.map(async (file) => {
                        var base64Image = file.data.replace(
                          /^data:image\/[a-z]+;base64,/,
                          '',
                        );

                        var dotIndex = file.filename.lastIndexOf('.');
                        var ext = file.filename
                          .substring(dotIndex)
                          .toUpperCase()
                          .replace(/\./g, '');

                        var imagePath = `Property\\P${ftc}\\P${ffc}\\P${response.data.propertyRef}\\O_${response.data.propertyRef}_${file.filename}`;

                        var ImagesRequestOptions = {
                          method: 'POST',
                          url: `/property/createanduploadpropertyextfile`,
                          headers: {
                            'Content-Type': 'application/json',
                          },
                          data: JSON.stringify({
                            Base64File: `${base64Image}`,
                            MetaData: {
                              RecordId: 0,
                              FileType: 1,
                              Rating: 0,
                              SequenceNo: 1,
                              FileExtension: `${ext}`,
                              FilePath: `${imagePath}`,
                              Description: `mobile upload of property images of ${values.firstname} ${values.surname}`,
                            },
                            FileName: `${file.filename}.jpg`,
                            PropertyRef: `${response.data.propertyRef}`,
                          }),
                        };

                        try {
                          return await axios(ImagesRequestOptions);
                        } catch (err) {}
                      }),
                    );

                    if (payload && base64StringWavAudio === null) {
                      setActiveSubmit(false);
                      setDisabled(false);
                      setIsSubmitting(false);
                      let message =
                        values.firstname !== undefined
                          ? `${values.firstname} ${values.surname}'s drafted property has been added`
                          : `${values.companyName}'s drafted property has been added`;
                      toast.success(`${message}`, {
                        position: 'top-center',
                        autoClose: 3000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                      });

                      const timer = setTimeout(() => {
                        navigate('/listingform', {
                          state: {
                            detail: values,
                            addressType: addressType,
                            propertyId: `${response.data.id}`,
                          },
                        });
                      }, 2000);
                      return () => clearTimeout(timer);
                    }
                  }

                  if (base64StringWavAudio) {
                    var audioPath = `Property\\P${ftc}\\P${ffc}\\P${response.data.propertyRef}\\O_${response.data.propertyRef}`;

                    var audioRequestOptions = {
                      method: 'POST',
                      url: '/property/createanduploadpropertyextfile',
                      headers: {
                        'Content-Type': 'application/json',
                      },
                      data: JSON.stringify({
                        Base64File: `${base64StringWavAudio}`,
                        MetaData: {
                          FileType: 2,
                          FileAccessId: 10,
                          Rating: 0,
                          SequenceNo: 1,
                          FileExtension: 'MP3',
                          FilePath: `${audioPath}`,
                          Description: `mobile upload of property audio of ${values.firstname} ${values.surname}`,
                        },
                        FileName: `${values.firstname}.mp3`,
                        PropertyRef: `${response.data.propertyRef}`,
                      }),
                    };

                    try {
                      await axios(audioRequestOptions);
                    } catch (err) {}

                    setActiveSubmit(false);
                    setDisabled(false);
                    setIsSubmitting(false);
                    let message2 =
                      values.firstname !== undefined
                        ? `${values.firstname} ${values.surname}'s drafted property has been added`
                        : `${values.companyName}'s drafted property has been added`;
                    toast.success(`${message2}`, {
                      position: 'top-center',
                      autoClose: 3000,
                      hideProgressBar: false,
                      closeOnClick: true,
                      pauseOnHover: true,
                      draggable: true,
                      progress: undefined,
                    });

                    const timer = setTimeout(() => {
                      navigate('/listingform', {
                        state: {
                          detail: values,
                          addressType: addressType,
                          propertyId: `${response.data.id}`,
                        },
                      });
                    }, 2000);
                    return () => clearTimeout(timer);
                  }

                  setActiveSubmit(false);
                  setDisabled(false);
                  setIsSubmitting(false);
                  let message =
                    values.firstname !== undefined
                      ? `${values.firstname} ${values.surname}'s drafted property has been added`
                      : `${values.companyName}'s drafted property has been added`;
                  toast.success(`${message}`, {
                    position: 'top-center',
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                  });

                  const timer = setTimeout(() => {
                    navigate('/listingform', {
                      state: {
                        detail: values,
                        addressType: addressType,
                        propertyId: `${response.data.id}`,
                      },
                    });
                  }, 2000);
                  return () => clearTimeout(timer);
                }
              })
              .catch((error) => {
                setActiveSubmit(false);
                setDisabled(false);
                setIsSubmitting(false);
                toast.error(
                  `Server error, ${error.message} The drafted property wasn't saved!,  try again later`,
                  {
                    position: 'top-left',
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                  },
                );
              });
          }
        })
        .catch((error) => {
          setActiveSubmit(false);
          setDisabled(false);
          setIsSubmitting(false);
          toast.error(
            `Server error, ${error.message} The drafted property wasn't saved!, try again later`,
            {
              position: 'top-left',
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              draggable: true,
              progress: undefined,
            },
          );
        });
    }
  }, [errors, isSubmitting, values]);

  useEffect(() => {
    postDataToAPI();
  }, [postDataToAPI]);

  const goBack = () => {
    navigate('/');
  };

  useEffect(() => {
    setValues((values) => ({ ...values, locations }));
  }, [locations]);

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const validationErrors = validate(values);
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length === 0) {
      setIsSubmitting(true);
    }
  };

  const handleChange = (event) => {
    event.preventDefault();
    event.persist();
    setValues((values) => ({
      ...values,
      [event.target.name]:
        [event.target.name] == 'passportNumber'
          ? event.target.value.toUpperCase()
          : event.target.value,
    }));
  };

  const handleVendorSelect = (vendor) => {
    if (vendor && typeof vendor === 'object') {
      setVendorAddressId(vendor.id);
      if (vendor.addressIndividual !== undefined) {
        setAddressType(vendor.addressIndividual ? 'false' : 'true');
      }

      const firstPhone =
        (vendor.addressPhones && vendor.addressPhones[0]?.telephoneNo) ||
        vendor.telephoneNumber;
      const firstEmail =
        (vendor.addressEmails && vendor.addressEmails[0]?.emailAddress) ||
        vendor.emailAddress;
      setValues((vals) => ({
        ...vals,
        firstname:
          vendor.firstName ||
          vendor.addressIndividualFirstName ||
          vals.firstname ||
          '',
        surname:
          vendor.surnameOrOrganisation ||
          vendor.addressIndividualSurname ||
          vendor.addressOrganisationName ||
          vals.surname ||
          '',
        passportNumber:
          vendor.idCardOrPassport ||
          vendor.addressIndividualIdCardNo ||
          vals.passportNumber ||
          '',
        companyName:
          vendor.addressOrganisationName ||
          vendor.addressFullName ||
          vals.companyName ||
          '',
        email: firstEmail || vals.email || '',
        mobileNo: firstPhone || vals.mobileNo || '',
      }));
      setErrors((errs) => {
        const {
          firstname,
          surname,
          passportNumber,
          companyName,
          companyNameReg,
          email,
          mobileNo,
          ...rest
        } = errs || {};
        return rest;
      });
    }
  };

  const handleRemoveVendor = () => {
    setVendorAddressId(null);
    setAddressType('false');
    setValues((vals) => ({
      ...vals,
      firstname: '',
      surname: '',
      passportNumber: '',
      companyName: '',
      companyNameReg: '',
      email: '',
      mobileNo: '',
    }));
    
    setErrors((errs) => {
      const {
        firstname,
        surname,
        passportNumber,
        companyName,
        companyNameReg,
        email,
        mobileNo,
        ...rest
      } = errs || {};
      return rest;
    });

  };

  const postAudioMp3 = async (blob) => {
    const blobToBase64 = (blob) =>
      new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });

    const convertBlobToBase64 = async (blob) => {
      // blob data
      const base64StringWav = await blobToBase64(blob);
      return base64StringWav;
    };
    let base64StringMp3 = await convertBlobToBase64(blob);
    setBase64StringWavAudio(base64StringMp3.split(',')[1]);
  };

  const handleUsedForChange = (event) => {
    event.preventDefault();
    event.persist();
    if (event.target.dataset.user !== usedFor) {
      setPropertyTypeId(null);
      setPropertySubTypeId(null);
      setPropertyTypeGroupId(null);
      refPropertyTypeId.current.state.value = null;
      refPropertySubTypeId.current.state.value = null;
      refStateId.current.state.value = null;
      setUsedFor(event.target.dataset.user);
    }
  };

  const handleAddressType = (event) => {
    event.preventDefault();
    event.persist();
    if (event.target.dataset.addresstype !== addressType) {
      setValues({});
      refPropertyTypeId.current.state.value = null;
      refPropertySubTypeId.current.state.value = null;
      refStreetId.current.state.value = null;
      refStateId.current.state.value = null;
      refLocalityId.current.state.value = null;
      setAvailableFor('false');
      setSoleAgency('0');
      setPropertyTypeGroupId(null);
      setErrors({});
      setIsSubmitting(false);
      setAddressType(event.target.dataset.addresstype);
      setPrice('');
    }
  };

  const handleAvailableForChange = (event) => {
    event.preventDefault();
    event.persist();
    setAvailableFor(event.target.dataset.available);
    setEmphyteusis(null);
  };

  const handleSoleAgencyChange = (event) => {
    event.preventDefault();
    event.persist();
    setSoleAgency(event.target.dataset.soleagency);
  };

  const handlePropertyTypeChange = (event) => {
    setPropertySubTypeId(null);
    refPropertySubTypeId.current.state.value = null;
    refStateId.current.state.value = null;
    setPropertyTypeApi(event.label);
    setPropertyTypeId(event.value);
    setPropertyTypeGroupId(event.propertyTypeGroupId);
  };

  const handlePropertySubTypeChange = (event) => {
    setPropertySubTypeId(event.value);
  };

  const handlePropertyStateChange = (event) => {
    setStateApi(event.label);
    setState(event.value);
  };

  const handleAreaTypeChange = (event) => {
    setAreaTypeId(event.value);
  };

  const handleLocalityChange = (event) => {
    setLocalityApi(event.label);
    setLocalityId(event.value);
    refStreetId.current.state.value = null;
  };

  const handleStreetChange = (event) => {
    setStreetId(event.value);
    setStreetName(event.label);
  };

  const handlePriceChange = (e) => {
    setPrice(e.target.value.trim());
  };

  useEffect(() => {
    switch (emphyteusis) {
      case '1':
        refGroundRent.current.value = '';
        refExpiresIn.current.value = '';
        refRevisableEvery.current.value = '';
        refGroundRent.current.disabled = true;
        refExpiresIn.current.disabled = true;
        refRevisableEvery.current.disabled = true;
        break;
      case '2':
        refRevisableEvery.current.value = '';
        refGroundRent.current.disabled = false;
        refExpiresIn.current.disabled = false;
        refRevisableEvery.current.disabled = true;
        break;
      case '3':
        refGroundRent.current.disabled = false;
        refExpiresIn.current.disabled = false;
        refRevisableEvery.current.disabled = false;
        break;
      case '4':
        refExpiresIn.current.value = '';
        refRevisableEvery.current.value = '';
        refGroundRent.current.disabled = false;
        refExpiresIn.current.disabled = true;
        refRevisableEvery.current.disabled = true;
        break;
      case '5':
        refExpiresIn.current.value = '';
        refGroundRent.current.disabled = false;
        refExpiresIn.current.disabled = true;
        refRevisableEvery.current.disabled = false;
        break;
    }
  }, [emphyteusis]);

  const handleEmphyteusisChange = (e) => {
    setEmphyteusis(e.value);
  };

  //multiple images
  const toBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () =>
        resolve({ data: reader.result, filename: file.name });
      reader.onerror = (error) => reject(error);
    });
  };

  const tobase64Handler = async (files) => {
    const filePathsPromises = [];
    Array.from(files).forEach((file) => {
      filePathsPromises.push(toBase64(file));
    });
    const filePaths = await Promise.all(filePathsPromises);
    return filePaths;
  };

  const handleUploadMultipleFiles = (e) => {
    e.persist();
    e.preventDefault();
    let fileObj = [];
    let fileArray = [];

    refImage.current.files = e.target.files ?? mountRefImages;

    fileObj.push(e.target.files);
    for (let i = 0; i < fileObj[0].length; i++) {
      if (fileObj[0][i].type !== 'image/jpeg') {
        setErrorImages((prevState) => ({
          ...prevState,
          type: 'Only images can be uploaded',
        }));
      }
      if (fileObj[0][i].size >= 10485760) {
        setErrorImages((prevState) => ({
          ...prevState,
          size: 'File too Big, please select a file less than 10mb',
        }));
      }
      fileArray.push(URL.createObjectURL(fileObj[0][i]));
    }

    setImages(fileArray);

    setImagesFiles([...fileObj]);

    if (e.target.files < 0 || !e.target.validity.valid) {
      return;
    }

    // refImage.current.files = e.target.files;
    tobase64Handler(e.target.files).then((data) => {
      setMulitpleFiles(data);
    });

    setMountRefImages(e.target.files);
  };

  const handleDeleteImage = (id) => {
    setImages((oldState) =>
      oldState.filter((item, index) => index !== id),
    );

    refImage.current.files = mountRefImages;

    const dt = new DataTransfer();
    Array.from(refImage.current.files).forEach((filev, index) => {
      if (id !== index) {
        dt.items.add(
          new File([filev], filev.name, { type: filev.type }),
        );
      }
    });

    let fileObj = [];

    fileObj.push(dt.files);

    setMountRefImages(dt.files);

    if (fileObj < 0) {
      return;
    }

    tobase64Handler(dt.files).then((data) => {
      setMulitpleFiles(data);
    });

    refImage.current.files = dt.files;
  };

  const priceFocus = () => {
    if (price !== null && price !== ' ') {
      setPrice(
        price
          .replace(/\.00$/, '')
          .replace(/[ ,.]/g, ' ')
          .replace(/ /g, ''),
      );
      return;
    }
    setPrice(null);
  };

  const handlePriceAutoComplete = () => {
    let priceMoney;
    if (price !== null && price !== '') {
      priceMoney = price
        .replace(/[ ,.]/g, '')
        .replace(/[K|k]/g, '*1000')
        .replace(/[M|m]/g, '*1000000')
        .replace(/[^0-9/*.]/g, '');

      var args = priceMoney.split('*');
      priceMoney = args.reduce((a, b) => a * b);
      let returnVal = numberWithCommas(priceMoney);
      setPrice(returnVal);
      return;
    }
    setPrice('');
  };

  const defaultCountryId = getSysSetting(AppConstants.SysSettingId_DefaultCountryId)?.intValue;
  const fetchLocality = () => {
    const options = {
      method: 'GET',
      url: `/lookuptoken/GetLocalitiesByCountryTokens`,
      params: { countryId: defaultCountryId },
      headers: {
        accept: 'application/json',
      },
    };

    return axios
      .request(options)
      .then(async (response) => {
        let options = await response.data.map((element) => {
          return { value: element.id, label: element.text };
        });
        return options;
      })
      .catch((error) => {});
  };

  const fetchStreets = (value) => {
    const options = {
      method: 'GET',
      url: `/lookuptoken/getstreetsbylocalitytokens`,
      params: { localityId: `${value}` },
    };

    return axios
      .request(options)
      .then(async (response) => {
        let options = await response.data.map((street) => {
          return {
            value: street.id,
            label: `${street.streetEx ? `${street.streetEx}, ` : ''}${
              street.text
            }`,
          };
        });
        return options;
      })
      .catch(() => {});
  };

  const fetchSoleAgency = () => {
    const options = {
      method: 'GET',
      url: '/lookuptoken/getsoleagencytypetokens',
    };

    return axios
      .request(options)
      .then((response) => {
        return response.data;
      })
      .catch(() => {});
  };

  const fetchType = (usedFor) => {
    const options = {
      method: 'GET',
      url: `/lookuptoken/getpropertytypesbyiscommercialtokens/${usedFor}`,
    };

    return axios
      .request(options)
      .then(async (response) => {
        let options = await response.data.map((element) => {
          return {
            value: element.id,
            label: element.text,
            propertyTypeGroupId: element.propertyTypeGroupId,
          };
        });
        return options;
      })
      .catch((error) => {});
  };

  const fetchSubType = (propertyTypeId) => {
    const options = {
      method: 'GET',
      url: `/lookuptoken/GetPropertySubTypesInTypeTokens`,
      params: { typeId: propertyTypeId }
    };

    return axios
      .request(options)
      .then(async (response) => {
        let options = await response.data.map((element) => {
          return {
            value: element.id,
            label: element.text,
            propertyTypeId: propertyTypeId,
          };
        });
        return options;
      })
      .catch((error) => {});
  };

  const fetchState = (propertyTypeGroupId) => {
    const options = {
      method: 'GET',
      url: '/lookuptoken/getpropertystateingrouptokens',
      params: { groupId: `${propertyTypeGroupId}` },
    };

    return axios
      .request(options)
      .then(async (response) => {
        let options = await response.data.map((element) => {
          return {
            value: element.id,
            label: element.text,
            propertyTypeId: element.propertyTypeId,
          };
        });
        return options;
      })
      .catch((error) => {});
  };

  const fetchAreaType = () => {
    const options = {
      method: 'GET',
      url: '/lookuptoken/GetPropertyAreaTypeTokens',
    };

    return axios
      .request(options)
      .then(async (response) => {
        let options = await response.data.map((element) => {
          return {
            value: element.id,
            label: element.text,
          };
        });
        return options;
      })
      .catch(() => {});
  };

  const { data: localityData } = useQuery(
    ['localityData'],
    fetchLocality,
    { refetchOnWindowFocus: false },
  );

  const { data: StreetData } = useQuery(
    ['StreetData', localityId],
    () => fetchStreets(localityId),
    { refetchOnWindowFocus: false, enabled: Boolean(localityId) },
  );

  const { isLoading: isLoadingSoleAgency, data: SoleAgencyData } =
    useQuery(['SoleAgencyData'], fetchSoleAgency, {
      refetchOnWindowFocus: false,
    });

  const { data: AreaTypeData } =
    useQuery(['AreaTypeData'], fetchAreaType, {
      refetchOnWindowFocus: false,
    });

  const { data: TypeData } = useQuery(
    ['TypeData', usedFor],
    () => fetchType(usedFor),
    { refetchOnWindowFocus: false, enabled: Boolean(usedFor) },
  );

  const { data: SubTypeData } = useQuery(
    ['SubTypeData', propertyTypeId],
    () => fetchSubType(propertyTypeId),
    { refetchOnWindowFocus: false, enabled: Boolean(propertyTypeId) },
  );

  const { data: StateData } = useQuery(
    ['StateData', propertyTypeGroupId],
    () => fetchState(propertyTypeGroupId),
    {
      refetchOnWindowFocus: false,
      enabled: Boolean(propertyTypeGroupId),
    },
  );

  const validate = (values) => {
    let errors = {};
    let regExp =
      /\+356 123-4567-890|\+3561234567890|\+356123-4567-890/i;
    if (addressType === 'false') {
      if (!values.firstname || values.firstname.trim() === '') {
        errors.firstname = 'Name is required';
      } else if (/\d/.test(values.firstname)) {
        errors.firstname = 'Name can not contain numbers';
      } else if (values.firstname.length === 0) {
        errors.firstname = 'Name is invalid';
      }

      if (!values.surname || values.surname.trim() === '') {
        errors.surname = 'Surname is required';
      } else if (/\d/.test(values.surname)) {
        errors.surname = 'Surname can not contain numbers';
      } else if (values.surname.length === 0) {
        errors.surname = 'Surname is invalid';
      }
    }

    if (addressType === 'true') {
      if (!values.companyName || values.companyName.trim() === '') {
        errors.companyName = 'Company name is required';
      } else if (values.companyName.length === 0) {
        errors.companyName = "Company's name is invalid";
      }
    }
    if (!values.mobileNo || values.mobileNo.trim() === '') {
      errors.mobileNo = 'Mobile Number is required';
    } else if (values.mobileNo.match(regExp)) {
      errors.mobileNo = 'Mobile Number is invalid';
    }
    if (!values.email || values.email.trim() === '') {
      errors.email = 'Email address is required';
    } else if (!/\S+@\S+\.\S+/.test(values.email)) {
      errors.email = 'Email address is invalid';
    }
    if (
      !values.propertyAddressDoorNo ||
      values.propertyAddressDoorNo == ''
    ) {
      errors.propertyAddressDoorNo =
        'Property Address Line 1 is required';
    }
    if (!localityId || localityId == '') {
      errors.localityId = 'Locality is required';
    }
    if (!streetId || streetId == '') {
      errors.streetId = 'Locality is required';
    }
    if (!propertyTypeId || propertyTypeId == '') {
      errors.propertyTypeId = 'Property Type is required';
    }
    if (!propertySubTypeId || propertySubTypeId == '') {
      errors.propertySubTypeId = 'Property Sub Type is required';
    }
    if (!price || price == '') {
      errors.price = 'Price is required';
    }
    if (!state || state == '') {
      errors.state = 'State is required';
    }
    if (!areaTypeId || areaTypeId == '') {
      errors.areaTypeId = 'Area Type is required';
    }
    const hasErrors = Object.keys(errors).length > 0;
    if (hasErrors) {
      const [firstError] = Object.values(errors);
      toast.error(firstError || 'Please input required field', {
        position: 'top-center',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
      
    return errors;
  };

  const getMyLocation = () => {
    const location = window.navigator && window.navigator.geolocation;
    if (location) {
      location.getCurrentPosition(
        (position) => {
          setLocations({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          });
          toast.success(`Coordinates captured`, {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        },
        (err) => {
          toast.error(`Sorry, Coordinates wasn't captured`, {
            position: 'top-left',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        },
      );
    }
  };

  const startWebAudioRecorder = async () => {
    setAudioData(null);
    function is_publish_supported() {
      return (
        navigator.mediaDevices &&
        navigator.mediaDevices.getUserMedia &&
        navigator.mediaDevices.enumerateDevices &&
        window.RTCPeerConnection &&
        window.RTCIceCandidate &&
        window.RTCSessionDescription
      );
    }

    console.log(
      'Unsupported debug - navigator.mediaDevices: ' +
        Boolean(navigator.mediaDevices),
    );
    console.log(
      'Unsupported debug - navigator.getUserMedia: ' +
        (Boolean(navigator.mediaDevices) &&
          Boolean(navigator.mediaDevices.getUserMedia)),
    );
    console.log(
      'Unsupported debug - navigator.enumerateDevices: ' +
        (Boolean(navigator.mediaDevices) &&
          Boolean(navigator.mediaDevices.enumerateDevices)),
    );
    console.log(
      'Unsupported debug - navigator.RTCPeerConnection: ' +
        Boolean(window.RTCPeerConnection),
    );
    console.log(
      'Unsupported debug - navigator.RTCIceCandidate: ' +
        Boolean(window.RTCIceCandidate),
    );
    console.log(
      'Unsupported debug - navigator.RTCSessionDescription: ' +
        Boolean(window.RTCSessionDescription),
    );

    is_publish_supported();

    if (
      navigator.mediaDevices &&
      navigator.mediaDevices.getUserMedia
    ) {
      try {
        var stream = await navigator.mediaDevices.getUserMedia({
          audio: true,
          // video: false,
        });
      } catch (err) {
        if (
          err.name == 'NotFoundError' ||
          err.name == 'DevicesNotFoundError'
        ) {
          toast.error(
            'Microphone not detected.',
            {
              position: 'top-center',
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            },
          );
          //required track is missing
        } else if (
          err.name == 'NotReadableError' ||
          err.name == 'TrackStartError'
        ) {
          toast.error('Mic are already in use', {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          //webcam or mic are already in use
        } else if (
          err.name == 'OverconstrainedError' ||
          err.name == 'ConstraintNotSatisfiedError'
        ) {
          toast.error(
            'The specified constraints resulted in no candidate devices which met the criteria requested.',
            {
              position: 'top-center',
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            },
          );
          //constraints can not be satisfied by avb. devices
        } else if (
          err.name == 'NotAllowedError' ||
          err.name == 'PermissionDeniedError'
        ) {
          toast.error(
            'User denies (or has previously denied) access to the webcam or microphone',
            {
              position: 'top-center',
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            },
          );
          //permission denied in browser
        } else if (
          err.name == 'TypeError' ||
          err.name == 'TypeError'
        ) {
          toast.error(
            'The constraints object passed to getUserMedia() is empty or has all tracks (audio, video or both) set to false',
            {
              position: 'top-center',
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            },
          );
          //empty constraints object
        } else {
          toast.error('other errors', {
            position: 'top-center',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          //other errors
        }
      }

      window.mediaRecorder = await new MediaRecorder(stream);
      window.mediaRecorder.start(100);

      clearInterval(increment.current);
      setTimer(0);

      if (
        'mediaRecorder' in window &&
        window.mediaRecorder.state === 'recording'
      ) {
        setRecState('recording');
        setRecStateMsg('recording...');
        increment.current = setInterval(() => {
          setTimer((timer) => timer + 1);
        }, 1000);
      }
    } else {
      toast.error('getUserMedia not supported on your browser!', {
        position: 'top-center',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  useEffect(() => {
    let concatChunks = [];
    if (
      'mediaRecorder' in window &&
      window.mediaRecorder.state === 'recording'
    ) {
      var dataChunks = [];
      window.mediaRecorder.ondataavailable = (e) => {
        if (e.data && e.data.size > 0) {
          dataChunks.push(e.data);
        }

        concatChunks = [...dataChunksAudio, ...dataChunks];

        setDataChunksAudio(concatChunks);
      };
    }
  }, [recState]);

  const stopWebAudioRecorder = () => {
    if (
      'mediaRecorder' in window &&
      (window.mediaRecorder.state === 'recording' ||
        window.mediaRecorder.state === 'paused')
    ) {
      setRecState('stopped');
      setRecStateMsg('stopped');
      window.mediaRecorder.stop();
      window.mediaRecorder.onstop = () => {
        let blob = new Blob(dataChunksAudio, { type: 'audio/mp3;' });
        let audioURL = window.URL.createObjectURL(blob);
        setAudioData(audioURL);
        postAudioMp3(blob);
      };

      clearInterval(increment.current);
    }
  };

  const pauseWebAudioRecorder = () => {
    if (
      'mediaRecorder' in window &&
      window.mediaRecorder.state === 'recording'
    ) {
      setRecState('paused');
      setRecStateMsg('paused');
      window.mediaRecorder.pause();
      clearInterval(increment.current);
    }
  };

  const resumeWebAudioRecorder = () => {
    if (
      'mediaRecorder' in window &&
      window.mediaRecorder.state === 'paused'
    ) {
      setRecState('resumeRecording');
      setRecStateMsg('resumed recording...');
      window.mediaRecorder.resume();
      increment.current = setInterval(() => {
        setTimer((timer) => timer + 1);
      }, 1000);
    }
  };

  const formatTime = () => {
    const getSeconds = `0${timer % 60}`.slice(-2);
    const minutes = `${Math.floor(timer / 60)}`;
    const getMinutes = `0${minutes % 60}`.slice(-2);
    const getHours = `0${Math.floor(timer / 3600)}`.slice(-2);
    return `${getHours} : ${getMinutes} : ${getSeconds}`;
  };

  const stopAndCloseAudio = () => {
    if (
      'mediaRecorder' in window &&
      (window.mediaRecorder.state === 'recording' ||
        window.mediaRecorder.state === 'paused')
    ) {
      window.mediaRecorder.stop();
      toast.success(`Recording stopped and audio deleted`, {
        position: 'top-center',
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      setAudioData(null);
      setRecState('');
      setDataChunksAudio([]);
      setRecStateMsg('');
      setBase64StringWavAudio('');
      clearInterval(increment.current);
      setTimer(0);
    }
  };

  if (isLoadingSoleAgency) {
    return <CenteredSpinner />;
  }

  if (activeSubmit) {
    return (
      <div className="container">
        <div className="row flex-column justify-content-center align-items-center vh-100">
          <CenteredSpinner />
          <h3 className="text-center">
            Please wait while we process your request.
          </h3>
        </div>
      </div>
    );
  }

  return (
    <div className="container pt-3 pb-4 property-form-page property-inspection-page">
      <div className="card shadow-sm border-0 overflow-hidden property-list-card">
        <div className="property-list-hero d-flex align-items-center px-4 py-3">
          <div className="property-list-hero-icon d-flex align-items-center justify-content-center">
            <i className="fas fa-clipboard-list" aria-hidden="true"></i>
          </div>
          <div className="ml-3">
            <p className="mb-1 text-uppercase text-white-50 small">Property Inspection</p>
            <h4 className="mb-0 text-white">Capture details in one flow.</h4>
          </div>
          <button
            type="button"
            className="btn btn-light btn-sm ml-auto property-list-back"
            onClick={() => navigate(-1)}
          >
            <i className="fas fa-arrow-left me-2"></i>
            Back
          </button>
        </div>
        <div className="p-4">
      <div className="row justify-content-center align-items-center ">
        <div className="col-12 col-md-12 col-xl-12">
          {/* <form onSubmit={handleSubmitToListingForm} id="validation-form" novalidate="novalidate"> */}
          <div className="form-group d-flex justify-content-between">
            <label className="col-sm-2 col-form-label p-0 w-100">
              Address type:
            </label>
            <div className="col-8 d-flex p-0">
              <div
                className={`button-belair w-50 ${
                  addressType === 'false' ? 'blend' : ''
                }`}
                onClick={vendorAddressId ? undefined : handleAddressType}
                data-addresstype="false"
                style={{ pointerEvents: vendorAddressId ? 'none' : 'auto', opacity: vendorAddressId ? 0.6 : 1 }}
              >
                Individual
              </div>
              <div
                className={`button-belair w-50 ${
                  addressType === 'true' ? 'blend' : ''
                }`}
                onClick={vendorAddressId ? undefined : handleAddressType}
                data-addresstype="true"
                style={{ pointerEvents: vendorAddressId ? 'none' : 'auto', opacity: vendorAddressId ? 0.6 : 1 }}
              >
                Organisation
              </div>
            </div>
          </div>
          <form
            onSubmit={handleSubmit}
            id="validation-form"
            noValidate="novalidate"
          >
            <button
              type="button"
              className="btn property-primary-btn d-block mb-3"
              onClick={vendorAddressId ? handleRemoveVendor : () => setShowVendorModal(true)}
            >
              {vendorAddressId ? 'Remove Owner' : 'Search Owner'}
            </button>
            {addressType === 'false' ? (
              <div className="form-group mb-0">
                <label className="form-label w-100" htmlFor="name">
                  Owner's First Name:{' '}
                </label>
                <input
                  autoComplete="on"
                  className={`form-control ${
                    errors.firstname && 'border-danger'
                  } d-block w-100 mb-2`}
                  type="text"
                  name="firstname"
                  onChange={handleChange}
                  value={values.firstname || ''}
                  required
                  placeholder="John"
                  id="firstname"
                  readOnly={Boolean(vendorAddressId)}
                />
              </div>
            ) : null}
            {addressType === 'false' && errors.firstname && (
              <small className="text-danger d-block mb-2">
                {errors.firstname}
              </small>
            )}
            {addressType === 'false' ? (
              <div className="form-group mb-0">
                <label className="form-label w-100" htmlFor="surname">
                  Owner's Surname:{' '}
                </label>
                <input
                  autoComplete="on"
                  className={`form-control ${
                    errors.surname && 'border-danger'
                  } d-block w-100 mb-2`}
                  type="text"
                  name="surname"
                  onChange={handleChange}
                  value={values.surname || ''}
                  required
                  placeholder="Doe"
                  id="surname"
                  readOnly={Boolean(vendorAddressId)}
                />
              </div>
            ) : null}
            {addressType === 'false' && errors.surname && (
              <small className="text-danger d-block mb-2">
                {errors.surname}
              </small>
            )}
            {addressType === 'false' ? (
              <div className="form-group mb-0">
                <label
                  className="form-label w-100"
                  htmlFor="passport"
                >
                  Owner's ID/Passport:
                </label>
                <input
                  className={`form-control d-block w-100 mb-2`}
                  type="text"
                  name="passportNumber"
                  onChange={handleChange}
                  value={values.passportNumber || ''}
                  placeholder="0585856M"
                  id="passport"
                  readOnly={Boolean(vendorAddressId)}
                />
              </div>
            ) : null}
            {addressType === 'true' ? (
              <div className="form-group mb-0">
                <label
                  className="form-label w-100"
                  htmlFor="passport"
                >
                  Company's name :
                </label>
                <input
                  className={`form-control ${
                    errors.companyName && 'border-danger'
                  } d-block w-100 mb-2`}
                  type="text"
                  name="companyName"
                  onChange={handleChange}
                  value={values.companyName || ''}
                  required
                  id="companyName"
                  readOnly={Boolean(vendorAddressId)}
                />
              </div>
            ) : null}
            {addressType === 'true' && errors.companyName && (
              <small className="text-danger d-block mb-2">
                {errors.companyName}
              </small>
            )}
            {addressType === 'true' ? (
              <div className="form-group mb-0">
                <label
                  className="form-label w-100"
                  htmlFor="passport"
                >
                  Company's reg. no. :
                </label>
                <input
                  className={`form-control ${
                    errors.companyNameReg && 'border-danger'
                  } d-block w-100 mb-2`}
                  type="text"
                  name="companyNameReg"
                  onChange={handleChange}
                  value={values.companyNameReg || ''}
                  id="companyNameReg"
                  readOnly={Boolean(vendorAddressId)}
                />
              </div>
            ) : null}
            {addressType === 'true' && errors.companyNameReg && (
              <small className="text-danger d-block mb-2">
                {errors.companyNameReg}
              </small>
            )}
            
            <label className="form-label mt-2 w-100">
              Mobile no. :{' '}
            </label>
            <div className="form-group d-flex justify-content-center align-items-center w-100 mb-2">
              <div className="w-100 col-3 p-0">
                <input
                  type="text"
                  autoComplete="off"
                  className="form-control"
                  value="+356"
                  disabled
                  placeholder="+356"
                />
              </div>
              <div className="w-100 col-9 p-0">
                <input
                  className={`form-control ${
                    errors.mobileNo && 'border-danger'
                  } d-block w-100`}
                  type="text"
                  name="mobileNo"
                  onChange={handleChange}
                  value={values.mobileNo || ''}
                  maxLength={10}
                  required
                  readOnly={Boolean(vendorAddressId)}
                />
              </div>
            </div>
            {errors.mobileNo && (
              <small className="text-danger d-block mb-2">
                {errors.mobileNo}
              </small>
            )}
            <div className="form-group mb-0">
              <label className="form-label w-100" htmlFor="email">
                Email:
              </label>
              <input
                autoComplete="off"
                className={`form-control ${
                  errors.email && 'border-danger'
                } d-block w-100 mb-2`}
                name="email"
                onChange={handleChange}
                value={values.email || ''}
                required
                placeholder="Joe@gmail.co.mt"
                id="email"
                readOnly={Boolean(vendorAddressId)}
              />
            </div>
            {errors.email && (
              <small className="text-danger d-block mb-2">
                {errors.email}
              </small>
            )}
            <div className="form-row justify-content-center">
              <div className="form-group col-12">
                <label className="form-label d-block w-100">
                  Property Address:
                </label>
                <div className="w-100">
                  <input
                    className={`form-control ${
                      errors.propertyAddressDoorNo && 'border-danger'
                    } d-block`}
                    type="text"
                    name="propertyAddressDoorNo"
                    onChange={handleChange}
                    value={values.propertyAddressDoorNo || ''}
                    required
                    placeholder="Address Line 1"
                  />
                  <input
                    className={`form-control d-block`}
                    type="text"
                    name="propertyAddressName"
                    onChange={handleChange}
                    value={values.propertyAddressName || ''}
                    required
                    placeholder="Address Line 2"
                  />
                  <select
                    className={`form-control d-block`}
                    name="propertyAddressCountry"
                    onChange={handleChange}
                    disabled
                  >
                    <option value="Malta">Malta</option>
                  </select>
                  <Select
                    className={`${
                      errors.localityId && 'react-select'
                    }`}
                    classNamePrefix={`${
                      errors.localityId && 'react-select'
                    }`}
                    onChange={handleLocalityChange}
                    ref={refLocalityId}
                    isSearchable={true}
                    options={localityData}
                  />
                  <Select
                    className={`${errors.streetId && 'react-select'}`}
                    classNamePrefix={`${
                      errors.streetId && 'react-select'
                    }`}
                    onChange={handleStreetChange}
                    ref={refStreetId}
                    isSearchable={true}
                    options={StreetData}
                  />
                </div>
              </div>
              <div className="form-group col-12 mb-0">
                <div className="mb-2">
                  <label className="form-label d-block w-100">
                    Property details:
                  </label>
                </div>
                <div className="w-100">
                  <div className="form-group d-flex justify-content-between">
                    <label className="col-sm-2 col-form-label p-0">
                      Used for:
                    </label>
                    <div className="col-8 d-flex p-0">
                      <div
                        className={`button-belair w-50 ${
                          usedFor === 'false' ? 'blend' : ''
                        }`}
                        onClick={handleUsedForChange}
                        data-user="false"
                      >
                        Residential
                      </div>
                      <div
                        className={`button-belair w-50 ${
                          usedFor === 'true' ? 'blend' : ''
                        }`}
                        onClick={handleUsedForChange}
                        data-user="true"
                      >
                        Commercial
                      </div>
                    </div>
                  </div>

                  <div className="form-group d-flex justify-content-between">
                    <label className="col-sm-2 col-form-label p-0">
                      Available for:
                    </label>
                    <div className="col-8 d-flex p-0">
                      <div
                        className={`button-belair w-50 ${
                          availableFor === 'false' ? 'blend' : ''
                        }`}
                        onClick={handleAvailableForChange}
                        data-available="false"
                      >
                        For Sale
                      </div>
                      <div
                        className={`button-belair w-50 ${
                          availableFor === 'true' ? 'blend' : ''
                        }`}
                        onClick={handleAvailableForChange}
                        data-available="true"
                      >
                        To Let
                      </div>
                    </div>
                  </div>

                  <div className="form-group d-flex justify-content-between">
                    <label className="col-sm-2 col-md-4 col-form-label p-0">
                      Sole Agency:
                    </label>
                    <div className="col-8 col-md-8 d-flex flex-wrap p-0">
                      {SoleAgencyData &&
                        React.Children.toArray(
                          [...SoleAgencyData]
                            .sort((a, b) => Number(a?.id) - Number(b?.id))
                            .map((SoleAgency) => (
                            <>
                              <div
                                className={`button-belair w-50 ${
                                  soleAgency == SoleAgency?.id
                                    ? 'blend'
                                    : ''
                                }`}
                                onClick={handleSoleAgencyChange}
                                data-soleagency={SoleAgency?.id}
                              >
                                {SoleAgency.text}
                              </div>
                            </>
                          )),
                        )}
                    </div>
                  </div>

                  {soleAgency > 1 ? (
                    <>
                      <div className="form-group d-flex justify-content-between mb-2">
                        <label className="col-md-2 col-form-label p-0">
                          Start Date:
                        </label>
                        <div className="col-8 p-0">
                          <DatePicker 
                            selected={soleAgencyStartDate} 
                            onChange={(date) => setSoleAgencyStartDate(date)}
                            dateFormat="dd/MM/yyyy"
                            placeholderText="Sole Agency Start Date"
                            customInput={
                              <input
                                autoComplete="off"
                                className="form-control d-block w-100 mb-2"
                                type="text"
                                onClick={(e) => e.preventDefault()} // prevent default if needed
                                value={
                                  soleAgencyStartDate
                                    ? new Date(soleAgencyStartDate).toLocaleDateString('en-GB') // dd/MM/yyyy
                                    : ''
                                }
                                readOnly // prevent direct editing
                                id="sa-start"
                              />
                            }
                          />
                        </div>
                      </div>

                      <div className="form-group d-flex justify-content-between mb-2">
                        <label className="col-md-2 col-form-label p-0">
                          End Date:
                        </label>
                        <div className="col-8 p-0">
                          <DatePicker 
                            selected={soleAgencyEndDate} 
                            onChange={(date) => setSoleAgencyEndDate(date)}
                            dateFormat="dd/MM/yyyy"
                            placeholderText="Sole Agency End Date"
                            customInput={
                              <input
                                autoComplete="off"
                                className="form-control d-block w-100 mb-2"
                                type="text"
                                value={
                                  soleAgencyEndDate
                                    ? new Date(soleAgencyEndDate).toLocaleDateString('en-GB')
                                    : ''
                                }
                                readOnly
                                id="sa-end"
                              />
                            }
                          />
                        </div>
                      </div>
                    </>
                  ) : null}


                  <div className="form-group d-flex">
                    <label
                      className="col-sm-2 col-md-4 col-form-label p-0"
                      htmlFor="type"
                    >
                      Type:
                    </label>
                    <div className="col-8 col-md-8 p-0">
                      <Select
                        className={`${
                          errors.propertyTypeId && 'react-select'
                        }`}
                        classNamePrefix={`${
                          errors.propertyTypeId && 'react-select'
                        }`}
                        onChange={handlePropertyTypeChange}
                        ref={refPropertyTypeId}
                        isSearchable={true}
                        options={TypeData}
                      />
                      {errors.propertyTypeId && (
                        <small className="form-text text-danger d-block">
                          {errors.propertyTypeId}
                        </small>
                      )}
                    </div>
                  </div>
                  <div className="form-group d-flex">
                    <label
                      className="col-sm-2 col-md-4 col-form-label p-0"
                      htmlFor="subtype"
                    >
                      Subtype:
                    </label>
                    <div className="col-8 col-md-8 p-0">
                      <Select
                        className={`${
                          errors.propertySubTypeId && 'react-select'
                        }`}
                        classNamePrefix={`${
                          errors.propertySubTypeId && 'react-select'
                        }`}
                        onChange={handlePropertySubTypeChange}
                        ref={refPropertySubTypeId}
                        isSearchable={true}
                        options={SubTypeData}
                      />
                      {errors.propertySubTypeId && (
                        <small className="form-text text-danger d-block">
                          {errors.propertySubTypeId}
                        </small>
                      )}
                    </div>
                  </div>
                  <div className="form-group d-flex">
                    <label
                      className="col-sm-2 col-md-4 col-form-label p-0"
                      htmlFor="state"
                    >
                      State:
                    </label>
                    <div className="col-8 col-md-8 p-0">
                      <Select
                        className={`${
                          errors.state && 'react-select'
                        }`}
                        classNamePrefix={`${
                          errors.state && 'react-select'
                        }`}
                        onChange={handlePropertyStateChange}
                        ref={refStateId}
                        isSearchable={true}
                        options={StateData}
                      />
                      {errors.state && (
                        <small className="form-text text-danger d-block">
                          {errors.state}
                        </small>
                      )}
                    </div>
                  </div>
                  <div className="form-group d-flex">
                    <label
                      className="col-sm-2 col-md-4 col-form-label p-0"
                      htmlFor="state"
                    >
                      Area Type:
                    </label>
                    <div className="col-8 col-md-8 p-0">
                      <Select
                        className={`${
                          errors.areaTypeId && 'react-select'
                        }`}
                        classNamePrefix={`${
                          errors.areaTypeId && 'react-select'
                        }`}
                        onChange={handleAreaTypeChange}
                        ref={refAreaTypeId}
                        isSearchable={true}
                        options={AreaTypeData}
                      />
                      {errors.areaTypeId && (
                        <small className="form-text text-danger d-block">
                          {errors.areaTypeId}
                        </small>
                      )}
                    </div>
                  </div>
                  <div className="form-group d-flex">
                    <label
                      className="col-sm-2 col-md-4 col-form-label p-0"
                      htmlFor="price"
                    >
                      Price{availableFor === 'true' ? ' Monthly:' : ':'}
                    </label>
                    <div className="col-8 col-md-8 p-0">
                      <input
                        id="price"
                        autoComplete="off"
                        className={`form-control ${
                          errors.price && 'border-danger'
                        } d-block w-100 mb-2`}
                        type="name"
                        name="price"
                        onChange={handlePriceChange}
                        onBlur={handlePriceAutoComplete}
                        onFocus={priceFocus}
                        value={price}
                        required
                        placeholder="100k"
                      />
                      {errors.price && (
                        <small className="form-text text-danger d-block">
                          {errors.price}
                        </small>
                      )}
                    </div>
                  </div>

                  {availableFor === 'false' ? (
                    <>
                      <div className="form-group d-flex justify-content-between mb-3">
                        <label className="col-md-2 col-form-label p-0">
                          Emphyteusis:
                        </label>
                        <div className="col-8 p-0">
                          <Select
                            classNamePrefix="react-select"
                            onChange={handleEmphyteusisChange}
                            options={emphyteusisData}
                          />
                        </div>
                      </div>
                      <div className="form-group d-flex justify-content-between mb-2">
                        <label className="col-md-2 col-form-label p-0">
                          Ground rent:
                        </label>
                        <div className="col-8 d-flex justify-content-center align-items-center p-0">
                          <input
                            autoComplete="off"
                            className={`form-control d-block w-100 mb-2`}
                            name="groundRent"
                            type="number"
                            disabled={true}
                            onChange={(e) =>
                              setGroundRent(e.target.value)
                            }
                            value={groundRent}
                            ref={refGroundRent}
                            id="ground-rent"
                          />
                          <p className="ml-2">(pa)</p>
                        </div>
                      </div>
                      <div className="form-group d-flex justify-content-between">
                        <label className="col-md-2 col-form-label p-0 mb-2">
                          Expires in:
                        </label>
                        <div className="col-8 p-0">
                          <input
                            autoComplete="off"
                            className={`form-control d-block w-100 mb-2`}
                            name="expiresIn"
                            type="number"
                            onChange={(e) =>
                              setExpiresIn(e.target.value)
                            }
                            value={expiresIn}
                            disabled={true}
                            ref={refExpiresIn}
                            id="expires-in"
                          />
                        </div>
                      </div>
                      <div className="form-group d-flex justify-content-between">
                        <label className="col-md-2 col-form-label p-0">
                          Revisable every:
                        </label>
                        <div className="col-8 d-flex justify-content-center align-items-center p-0">
                          <input
                            autoComplete="off"
                            className={`form-control d-block w-100 mb-2`}
                            name="revisableEvery"
                            type="number"
                            onChange={(e) =>
                              setRevisableEvery(e.target.value)
                            }
                            value={revisableEvery}
                            disabled={true}
                            ref={refRevisableEvery}
                            id="revisable-every"
                          />
                          <p className="ml-2">(years)</p>
                        </div>
                      </div>
                    </>
                  ) : null}

                  {availableFor === 'true' ? (
                    <>
                      <div className="form-group d-flex justify-content-between mb-2">
                        <label className="col-md-2 col-form-label p-0">
                          Next Available:
                        </label>
                        <div className="col-8 d-flex justify-content-center align-items-center p-0">
                          <DatePicker 
                            selected={startDate} 
                            onChange={(date) => setStartDate(date)}
                            dateFormat="dd/MM/yyyy"
                            placeholderText="Next Available Date"
                            customInput={
                            <input
                              autoComplete="off"
                              className={`form-control d-block w-100 mb-2`}
                              type="text"
                              onChange={(e) =>
                                setGroundRent(e.target.value)
                              }
                              value={groundRent}
                              ref={refGroundRent}
                              id="ground-rent"
                            />
                            } />
                        </div>
                      </div>
                    </>
                  ) : null}

                </div>
              </div>
            </div>
            <div className="form-row d-flex justify-content-between mt-2 align-items-center mb-3">
              <div className="col-1 mb-2">
                <i className="fas fa-location-arrow align-middle"></i>
              </div>
              <div className="col-11 mb-2">
                <button
                  type="button"
                  className="btn property-primary-btn d-block mb-0"
                  onClick={getMyLocation}
                >
                  Capture Google Location
                </button>
              </div>
            </div>
            <div className="d-flex justify-content-between align-items-center mt-4 mb-4">
              <button
                type="button"
                className="btn property-secondary-btn d-block mb-0"
                onClick={goBack}
              >
                <i className="fas fa-arrow-left me-2" style={{ color: '#6c757d' }}></i>
                Back
              </button>
              <div className="d-flex justify-content-between align-items-center">
                <div
                  className="cursor-item nav-icon-button"
                  onClick={() => setShowImage(true)}
                  title="Add images"
                >
                  <i className="fas fa-camera fa-lg" aria-hidden="true"></i>
                </div>
                <div
                  className="cursor-item nav-icon-button"
                  onClick={() => setShowRecorder(true)}
                  title="Record audio"
                >
                  <i className="fas fa-microphone fa-lg" aria-hidden="true"></i>
                </div>
              </div>
              <button
                type="submit"
                className="btn property-primary-btn"
                disabled={disabled}
                onClick={(event) => {
                  handleSubmit(event);
                }}
              >
                {disabled ? 'Submitting...' : 'Submit'}
              </button>
            </div>
          </form>

          <AudioModal
            showRecorder={showRecorder}
            setShowRecorder={setShowRecorder}
            stopAndCloseAudio={stopAndCloseAudio}
            audioData={audioData}
            recStateMsg={recStateMsg}
            formatTime={formatTime}
            startWebAudioRecorder={startWebAudioRecorder}
            pauseWebAudioRecorder={pauseWebAudioRecorder}
            resumeWebAudioRecorder={resumeWebAudioRecorder}
            stopWebAudioRecorder={stopWebAudioRecorder}
            increment={increment}
            recState={recState}
            setAudioData={setAudioData}
            setRecState={setRecState}
            setDataChunksAudio={setDataChunksAudio}
            setBase64StringWavAudio={setBase64StringWavAudio}
            clearInterval={clearInterval}
            setTimer={setTimer}
            setRecStateMsg={setRecStateMsg}
            dialogClassName="property-modal"
          />
          <Modal show={showImage} centered backdrop="static" dialogClassName="property-modal">
            <Modal.Header
              closeButton
              onClick={() => {
                setShowImage(false);
                setErrorImages(null);
                // setImages(null);
              }}
            >
              <Modal.Title><span className='font-weight-bold'>Upload Property Images</span></Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {images !== null ? (
                <>
                  <div className="grid-container-images">
                    {(images || []).map((url, index) => (
                      <img
                        key={index}
                        src={url}
                        alt="property images"
                        height="200px"
                        style={{ objectFit: 'cover' }}
                        className=""
                        onClick={() => handleDeleteImage(index)}
                      />
                    ))}
                  </div>
                  <br />
                  {images !== null && images.length > 0 ? (
                    <button
                      onClick={() => {
                        setImages(null);
                        setMulitpleFiles(null);
                        setErrorImages(null);
                      }}
                      className="mt-2 mb-2 btn property-secondary-btn"
                    >
                      {images.length > 1
                        ? 'Remove all images'
                        : 'Remove image'}
                    </button>
                  ) : null}
                </>
              ) : null}
              <p>
                {images?.length > 0
                  ? errorImages && errorImages.type
                  : null}
              </p>
              <p>
                {images?.length > 0
                  ? errorImages && errorImages.size
                  : null}
              </p>
              <br />
              <div className="form-group">
                <input
                  type="file"
                  className="form-control"
                  onChange={(e) => handleUploadMultipleFiles(e)}
                  accept="image/*"
                  multiple
                  ref={refImage}
                />
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button
                  variant='danger'
                  onClick={() => {
                    setShowImage(false);
                  }}
                >
                  Cancel
              </Button>
              {multipleFiles !== null && multipleFiles.length > 0 ? (
                <button
                  onClick={() => {
                    setShowImage(false);
                    setErrorImages(null);
                    toast.success(`Images saved`, {
                      position: 'top-center',
                      autoClose: 3000,
                      hideProgressBar: false,
                      closeOnClick: true,
                      pauseOnHover: true,
                      draggable: true,
                      progress: undefined,
                    });
                  }}
                  className="mt-2 mb-2 btn property-primary-btn"
                >
                  Save
                </button>
              ) : null}
          </Modal.Footer>
        </Modal>
        <VendorSearchModal
          show={showVendorModal}
          setShow={setShowVendorModal}
          onSelect={handleVendorSelect}
        />
      </div>
    </div>
    </div>
  </div>
</div>
);
}
